import { render, staticRenderFns } from "./AssignAssets.vue?vue&type=template&id=43034642"
import script from "./AssignAssets.js?vue&type=script&lang=js&external"
export * from "./AssignAssets.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports